module.exports = __webpack_public_path__ + "img/Ramit.4184f8de.png";